/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IWebgroupSearchResultsViewProps } from './webgroup-search-results';
import Msdyn365 from '@msdyn365-commerce/core';
import { format } from '@msdyn365-commerce-modules/utilities';

export default (props: IWebgroupSearchResultsViewProps) => {
    const {
        searchProducts,
        searchCategories,
        query,
        searchTerm,
        categoryName,
        categoryId,
        breadcrumb,
        slots: { webgroupDirectory },
        resources: { showingResultsFor }
    } = props;
    if (Msdyn365.isBrowser && (searchTerm || query)) {
        setTimeout(() => {
            const text = (searchTerm && searchTerm) || (query && query) || '';
            const searchInput = document.querySelectorAll('.ms-search__form-control')[0] as HTMLInputElement;
            searchInput.value = text;
        }, 100);
    }
    const showCategories =
        (Array.isArray(searchCategories) && searchCategories.length) ||
        //@ts-ignore
        (React.isValidElement(searchCategories) && searchCategories.props.children) ||
        (!React.isValidElement(searchCategories) && searchCategories);
    return (
        <div className='webgroup-search-results'>
            {query ? (
                <>
                    <h3 className='search-title'>{format(showingResultsFor, query)}</h3>
                    {showCategories && (
                        <div className='search-categories-wrapper'>
                            <div className='search-categories'>{searchCategories}</div>
                        </div>
                    )}
                    {searchProducts && <div className='search-products'>{searchProducts}</div>}
                </>
            ) : null}
            {categoryId ? (
                <>
                    {breadcrumb && <div className='breadcrumbs'>{breadcrumb}</div>}
                    <h2 className='search-title'>{categoryName}</h2>
                    {showCategories && (
                        <div className='search-categories-wrapper'>
                            <div className='search-categories'>{searchCategories}</div>
                        </div>
                    )}
                    {webgroupDirectory && <div className='search-groups'>{webgroupDirectory}</div>}
                </>
            ) : null}
        </div>
    );
};
